export default __webpack_public_path__ + "static/thumb-landscape-d9fdacbd059c08efd1f8a97f5e24cb57.jpg";